import themes from './reducers'

export { setTheme } from './actions'
export { getTheme, getThemeTemplate } from './selectors'

export default themes
